// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LayoutFilledSvg from "@fishx/icons-svg/es/asn/LayoutFilled";
import FishxIcon from '../components/FishxIcon';

var LayoutFilled = function LayoutFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: LayoutFilledSvg
  }));
};

LayoutFilled.displayName = 'LayoutFilled';
export default React.forwardRef(LayoutFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/LayoutFilled.js
// module id = 3009
// module chunks = 0